import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { Register, DynamicComponent } from '@xanadu/core';
import { SafeStyle } from '@angular/platform-browser';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[style]': 'hostStyle'
    }
})
@Register('tree')
export class TreeComponent extends DynamicComponent {
    hostStyle?: SafeStyle;

    constructor() {
        super();

        effect(() => {
            const model = this.model();

            if (model.hostStyle) {
                this.hostStyle = model.hostStyle;
            }
        });
    }
}
